import { filter, mergeMap, of, switchMap } from 'rxjs'
import { catchError, withLatestFrom } from 'rxjs/operators'
import type { Epic } from '../../../index.js'
import { Actions } from '../../../Slice/index.js'

export const GetAllDatasetsEpic: Epic = (action$, state$, { order, OrderRepository }) =>
  action$.pipe(
    filter(Actions.order.getAllDatasetRequest.match),
    withLatestFrom(state$),
    // The store holds one order's pools: an answer for an order asked about before the latest must not land.
    switchMap(([action]) => {
      return OrderRepository.getAllSamplePools(action.payload).pipe(
        mergeMap((response) => of(order.getAllDatasetSuccess(response, action.payload.orderId))),
        catchError((error) => of(order.getAllDatasetFailure(error)))
      )
    })
  )
